import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { profiloAriannaSelector } from "../../../modules/screening/selectors"
import { ricercaComuniSelector, ricercaIscrizioneSelector } from "../../../modules/anagrafe/selectors"
import { useEffect, useMemo, useState } from "react"
import { AuthComp } from "../../../auth/AuthComp"
import { Redirect } from "../../tools/Redirect"
import { LOGIN, RICEVIADOMICILIO } from "../../../global/urlMapping"
import { Box } from "@mui/system"
import { Button, Grid, MenuItem, TextField, Typography } from "@mui/material"
import { isNotNullUndefined, validateAddress, validateMail, validateMunicipalityCode, validateTelefono, validateZipCode } from "../../../functions/inputValidation"
import { patchProfiloAriannaAction } from "../../../modules/screening/actions"
import { checkScreeningCLSelector } from "../../../modules/screeningColonRetto/selectors"
import { DomicilioAttivoAsl } from "../../multiAslComponent/DomicilioAttivoAsl"

export const ModificaIndirizzoSpedizione = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const profiloArianna = useSelector(profiloAriannaSelector)
    const ricercaComuni = useSelector(ricercaComuniSelector)
    const checkScreeningCL = useSelector(checkScreeningCLSelector)
    const datiIscrizioneAsr = useSelector(ricercaIscrizioneSelector)?.value?.DatiMinimiIscrizione
    const aslAssistito = datiIscrizioneAsr?.CodiceAreaAssistenza ?? datiIscrizioneAsr?.CodiceAslAssistenza

    const [indirizzo, setIndirizzo] = useState(validateAddress(profiloArianna?.value?.patient?.screeningAddress));
    const [zipCode, setZipCode] = useState(validateZipCode(profiloArianna?.value?.patient?.screeningZipCode));
    const [municipalityCode, setMunicipalityCode] = useState(validateMunicipalityCode(profiloArianna?.value?.patient?.screeningMunicipalityCode));
    const [telefono, setTelefono] = useState(validateTelefono(profiloArianna?.value?.patient?.personalMobile));
    const [mail, setMail] = useState(validateMail(profiloArianna?.value?.patient?.personalEmail));

    const invite = location?.state?.invite;

    const isHidden = (invite === undefined || invite === null) && checkScreeningCL?.status !== 200;


    const handleChange = (e) => {
        const { name, value } = e.target;
        switch (name) {
            case "telefono":
                setTelefono(validateTelefono(value))
                break;
            case "mail":
                setMail(validateMail(value))
                break;
            case "screeningAddress":
                setIndirizzo(validateAddress(value));
                break;
            case "screeningMunicipalityCode":
                setMunicipalityCode(validateMunicipalityCode(value))
                break;
            case "screeningZipCode":
                setZipCode(validateZipCode(value))
                break;
            default:
                break;
        }
    }

    const buttonSalvaIsDisabled = () => {
        return (indirizzo.error || municipalityCode.error || zipCode.error || telefono.error || mail.error)
    }

    const salvaIndirizzo = () => {

        if (!isNotNullUndefined(indirizzo.value).error &&
            !isNotNullUndefined(municipalityCode.value).error &&
            !isNotNullUndefined(zipCode.value).error &&
            !isNotNullUndefined(telefono.value).error) {
            const patientInfoBody = {
                "screeningTypeCode": "CL",
                "address": indirizzo.value,
                "municipalityCode": municipalityCode.value,
                "zipCode": zipCode.value,
                "mobile": telefono.value,
                "email": mail.value
            }

            dispatch(patchProfiloAriannaAction(patientInfoBody))
            navigate(RICEVIADOMICILIO, { state: { invite } });
        }
    }

    const comuni = useMemo(() => {
        return ricercaComuni?.value?.Comuni?.map((comune) => ({
            CodIstat: aslAssistito === '070103' ? comune.CodIstat.substring(1) : comune.CodIstat,
            NomeComune: comune?.NomeComune
        }))
    }, [ricercaComuni, aslAssistito]);

    useEffect(() => {
        window.scrollTo(0, 0)
        if (isHidden)
            navigate(-1)
    }, [isHidden, navigate])

    return (
        <>
            <AuthComp fallback={< Redirect link={LOGIN} />} >
                <DomicilioAttivoAsl  >
                    {

                        <Box className="emptyBg" sx={{
                            flexGrow: 1,
                            overflow: 'hidden',
                            with: "100%"
                        }}>
                            <Box sx={{ x: 'auto' }}>
                                <Grid container wrap="nowrap" spacing={2}>
                                    <Grid item xs zeroMinWidth>

                                        <Box sx={{ width: "100%", height: "150px", display: "flex" }}>
                                            <Typography
                                                component='h1'
                                                sx={{
                                                    color: "#005397",
                                                    margin: "auto",
                                                    textAlign: "center",
                                                    fontSize: { xs: "25px", md: "40px" },
                                                    fontWeight: 700,
                                                }}
                                            >
                                                Ricevi kit ed esito presso la tua residenza o tuo
                                                domicilio
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ my: 4, mx: 'auto', paddingBottom: "20vh" }}>
                                <Grid container wrap="nowrap" spacing={2}>
                                    <Grid item> </Grid>
                                    <Grid item xs zeroMinWidth>
                                        <Box
                                            sx={{
                                                width: "100%",
                                                margin: "auto",
                                                display: "flex",
                                                flexDirection: "column",
                                            }}
                                        >
                                            <Box
                                                sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}
                                            >
                                                <TextField
                                                    error={indirizzo.error}
                                                    helperText={<Typography component={'span'} sx={{ wordWrap: 'break-word', fontWeight: 600 }}>
                                                        {indirizzo.messageError}
                                                    </Typography>}
                                                    onChange={handleChange}
                                                    variant="standard"
                                                    value={indirizzo.value}
                                                    name="screeningAddress"
                                                    label="Indirizzo"
                                                    autoFocus
                                                    sx={{ width: { xs: "90%", md: "50%" }, mb: "20px" }}
                                                    autoComplete="off"
                                                />
                                                <TextField
                                                    error={zipCode.error}
                                                    helperText={<Typography component={'span'} sx={{ wordWrap: 'break-word', fontWeight: 600 }}>
                                                        {zipCode.messageError}
                                                    </Typography>}
                                                    onChange={handleChange}
                                                    variant="standard"
                                                    value={zipCode.value}
                                                    name="screeningZipCode"
                                                    label="Codice cap"
                                                    autoFocus
                                                    sx={{ width: { xs: "90%", md: "50%" }, mb: "20px" }}
                                                    autoComplete="off"
                                                />
                                                <TextField
                                                    error={municipalityCode.error}
                                                    helperText={<Typography component={'span'} sx={{ wordWrap: 'break-word', fontWeight: 600 }}>
                                                        {municipalityCode.messageError}
                                                    </Typography>}
                                                    onChange={handleChange}
                                                    value={municipalityCode.value}
                                                    name="screeningMunicipalityCode"
                                                    select
                                                    label="Comune"
                                                    variant="standard"
                                                    autoFocus
                                                    sx={{ width: { xs: "90%", md: "50%" }, mb: "20px" }}
                                                >

                                                    {comuni?.map((comune) => (
                                                        <MenuItem key={comune?.CodIstat} value={comune?.CodIstat}>
                                                            {comune?.NomeComune}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>

                                                <TextField
                                                    error={telefono.error}
                                                    helperText={<Typography component={'span'} sx={{ wordWrap: 'break-word', fontWeight: 600 }}>
                                                        {telefono.messageError}
                                                    </Typography>}
                                                    onChange={handleChange}
                                                    variant="standard"
                                                    value={telefono?.value}
                                                    name="telefono"
                                                    label="Telefono"
                                                    autoFocus
                                                    sx={{ width: { xs: "90%", md: "50%" }, mb: "20px" }}
                                                    autoComplete="off"
                                                />
                                                <TextField
                                                    error={mail.error}
                                                    helperText={<Typography component={'span'} sx={{ wordWrap: 'break-word', fontWeight: 600 }}>
                                                        {mail.messageError}
                                                    </Typography>}
                                                    onChange={handleChange}
                                                    variant="standard"
                                                    value={mail.value}
                                                    name="mail"
                                                    label="E-mail"
                                                    autoFocus
                                                    sx={{ width: { xs: "90%", md: "50%" }, mb: "20px" }}
                                                    autoComplete="off"
                                                />
                                            </Box>
                                            <Box sx={{ height: "100px", width: "100%", display: "flex", paddingTop: "10px", paddingBottom: "20px" }}>
                                                <Button
                                                    disabled={buttonSalvaIsDisabled()}
                                                    onClick={() => {
                                                        salvaIndirizzo()
                                                    }}
                                                    variant="contained"
                                                    disableRipple
                                                    disableFocusRipple
                                                    disableTouchRipple
                                                    sx={{
                                                        backgroundColor: "#005397",
                                                        margin: "auto",
                                                        minHeight: "50px",
                                                        width: "70%",
                                                        borderRadius: "20px !important",
                                                        color: "white",
                                                        fontSize: '18px',
                                                        fontWeight: 600,
                                                        "&:hover": { backgroundColor: "#DCEEFE", borderColor: '#DCEEFE', borderWidth: '2px', color: "white" },
                                                    }}
                                                >
                                                    Aggiorna indirizzo di spedizione

                                                </Button>
                                            </Box>


                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    }
                </DomicilioAttivoAsl>
            </AuthComp>
        </>
    )
}